import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';
import './TripSelect.css';

const RouteSelect = ({
    routes,
    routesLoading,
    values,
    setFieldValue,
    setRoutes,
    searchDebounce,
    fetchAgencyRoutes,
    onRouteMenuScrollToBottom,
    onRouteInputChange
}) => {
    // Custom formatOptionLabel to show route details
    const formatOptionLabel = ({ label }) => (
        <div className="trip-option" title={label}>
            <span>{label}</span>
        </div>
    );

    return (
        <Form.Group className="mb-3">
            <Form.Label>Select Route</Form.Label>
            <Select
                options={routes?.map((route) => ({
                    label: `${route.route_short_name || ''}${route.route_long_name ? ` - ${route.route_long_name}` : ''}`,
                    value: route._id
                }))}
                isLoading={routesLoading}
                onInputChange={(newValue) => {
                    if (typeof newValue === 'string') {
                        if (onRouteInputChange) {
                            onRouteInputChange(values?.agency_id, newValue, setRoutes);
                        } else if (searchDebounce) {
                            searchDebounce(values?.agency_id, newValue, setRoutes);
                        }
                    }
                }}
                onMenuScrollToBottom={() => {
                    if (onRouteMenuScrollToBottom) {
                        onRouteMenuScrollToBottom(values?.agency_id, setRoutes);
                    }
                }}
                onChange={(selectedOption) => {
                    setFieldValue('start_route_id', selectedOption.value);
                    setFieldValue('start_trip_id', '');
                    fetchAgencyRoutes(values?.agency_id, values?.transit_types, setRoutes);
                }}
                formatOptionLabel={formatOptionLabel}
                placeholder="Select a route"
                classNamePrefix="react-select"
                isClearable // Allow clearing selection
                aria-label="Select route" // Accessibility
            />
        </Form.Group>
    );
};

export default RouteSelect; 